export enum AuthProviderType {
  none = 'none',
  email = 'email',
  social = 'social',
}
